/*
  elewa-diacritics.js
  -------------------
  What it does: fixes how Yoruba letters with a dot below AND a tone mark display in the
  Fraunces display font. Fraunces puts the tone mark beside "ọ́" or "ẹ́" instead of above it
  when the letter is typed the usual way (ọ + accent). Swapping the order (ó + dot below)
  makes it display correctly. The text reads exactly the same; only the stored order of
  the marks changes, and only on the page, never in Shopify admin.
  Where it's used: loaded on every page by layout/theme.liquid. It only touches headings
  and elements with the class "elewa-display" (everything set in Fraunces).
  Body text is in Nunito Sans, which displays these letters fine, so it's left alone.
*/
(function () {
  var DOT_BELOW = '̣';
  // vowel with dot below + tone mark  ->  vowel with tone mark + dot below
  var MAP = {
    '\u1eb9\u0301': '\u00e9', '\u1eb9\u0300': '\u00e8', // ẹ́ ẹ̀
    '\u1ecd\u0301': '\u00f3', '\u1ecd\u0300': '\u00f2', // ọ́ ọ̀
    '\u1eb8\u0301': '\u00c9', '\u1eb8\u0300': '\u00c8', // Ẹ́ Ẹ̀
    '\u1ecc\u0301': '\u00d3', '\u1ecc\u0300': '\u00d2'  // Ọ́ Ọ̀
  };
  var PATTERN = /[ẹọẸỌ][́̀]/g;
  var HAS_PAIR = /[ẹọẸỌ][́̀]/;
  var SELECTOR = 'h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, .elewa-display, .elewa-home__greet, .elewa-closing, .elewa-closing-short, .elewa-band__title, .elewa-name, .elewa-mag__lead, .elewa-mag__sign, .elewa-mag__tile-title, .elewa-home__ptitle';

  function fixText(text) {
    // NFC first, so letters typed as plain o + dot below + accent are caught too.
    return text.normalize('NFC').replace(PATTERN, function (pair) {
      return MAP[pair] + DOT_BELOW;
    });
  }

  function fixElement(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (HAS_PAIR.test(node.nodeValue.normalize('NFC'))) {
        node.nodeValue = fixText(node.nodeValue);
      }
    }
  }

  function run(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(fixElement);
  }

  document.addEventListener('DOMContentLoaded', function () { run(); });
  // Re-run when the theme editor reloads a section.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
